var CartPage = {};
CartPage.init = function () {

  $('.cart__table .item-row').each(function (i, row) {
    var id = row.id;
    var product = row.getAttribute("data-product");
    var version = row.getAttribute("data-version");

    $(row).find('button.plus').click(function (event) {
      Cart.plusItem(id).then(function (resp) {
        if (resp.status === 400) {
          Cart.showOutOfStockModel(resp.errors.cartItem.size, resp.errors.cartItem.version);
          return;
        }
        document.location.reload();
      });
    });

    $(row).find('.add-engraving').click(function () {
      EngraveModal.loadModal({_id: product, version: version}, {
        onAddToCart: function (engraveItem) {
          Cart.addItems([engraveItem], {showMinicart: false, updateMinicart: false}, function (err, result) {
            if (!err) {
              document.location.reload();
            }
          });
        }
      })
    });

    $('.engrave_modal_open').click(ProductPage.openEngraveModal);

    $(row).find('.engrave_edit').click(function () {
      Cart.loadItem(id).then(function (resp) {
        EngraveModal.loadModal({_id: product, version: version}, {
          edit: true,
          item: resp,
          onAddToCart: function (item) {
            return Cart.updateProduct(item).then(function (result) {
              document.location.reload();
            });
          }
        });
      });
    });

    $(row).find('.opensizes').click(function (e) {
      e.preventDefault();
      var that = this;
      if ($(that).hasClass('opened')) {
        $(that).removeClass('opened');
        $('.sizes').slideUp(300);
      } else {
        jQuery.ajax({
          url: "/cart/" + id + "/versions/" + version,
          method: "get",
          contentType: 'application/json; charset=utf-8',
          success: function (resp) {
            $(that).addClass('opened');
            $('.sizes').html(resp.html).slideDown(300);
            $('.sizeTableLink').click(function() {
              jQuery.ajax({
                url: "/product/" + product + "/sizeTable",
                method: "get",
                contentType: 'application/json; charset=utf-8',
                success: function (resp) {
                  $('#sizeTableModal').remove();
                  $('body').append(resp.html);
                  $('#sizeTableModal').popup('show');
                }
              });
            })
          }
        });
      };
    });

    $(row).find('button.minus').click(function (event) {
      Cart.minusItem(id).then(function (resp) {
        document.location.reload();
      });
    });

    $(row).find('button.delete').click(function (event) {
      event.preventDefault();
      $(row).remove();
      Cart.removeItem(id).then(function () {
        document.location.reload();
      });
    });
  });

  $('.remove-promocode').click(function (evt) {
    evt.preventDefault();
    Cart.clearPromoCode().then(function () {
      document.location.reload();
    });
  });
};

$(CartPage.init);
